export default __webpack_public_path__ + "static/media/towera.76ad4dbb.png";